import React, { useState } from 'react';
import AffiliatesAPI from 'api/AffiliatesAPI';
import { useSnackbar } from 'notistack';

interface IAddAffiliate {
  setAddMode: any;
  setAffiliate: any;
  getCurAffiliate: any;
  affiliate: any;
}

const AddAffiliate: React.FC<IAddAffiliate> = ({ setAddMode, setAffiliate, getCurAffiliate, affiliate }) => {
  const [ email, setEmail ] = useState<string>('');
  const { enqueueSnackbar } = useSnackbar();

  const requestJoin = async(emailToFind: string) => {
    const mongoReq = {
      query: {
        admin: emailToFind,
      },
    };
    const findAffiliate = await AffiliatesAPI.retrieveAffiliate(mongoReq);
    if (findAffiliate?.success) {
      const updates = {
        _id: findAffiliate?.result[0]._id,
        pending: {
          aff_id: affiliate.data._id,
          name: affiliate.data.name,
          admin: affiliate.data.admin,
          type: 'external'
        }
      };
      const res = await AffiliatesAPI.updateAffiliate(updates);
      if (res?.success) {
        setAffiliate({ isLoading: true, data: {} });
        setAddMode(false);
        enqueueSnackbar('Invite request sent!', { variant: 'success' });
        getCurAffiliate();
      } else {
        enqueueSnackbar('Failed to send invite request. User may not be owner of an affiliation', { variant: 'error' });
      }
    } else {
      enqueueSnackbar('Failed to send invite request. User may not be owner of an affiliation', { variant: 'error' });
    }
  };

  return (
    <div className='add-affiliate-container'>
      <div className='add-affiliate-header'>
        <div className='add-affiliate-header-content'>
          <div className='add-affiliate-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M12 5V19M5 12H19' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='add-affiliate-header-group'>
            <div className='add-affiliate-header-primary'>
              Add Affiliate
            </div>
            <div className='add-affiliate-header-secondary'>
              Enter the email of the team admin whose team you wish to invite.
            </div>
          </div>
        </div>
        <div className='add-affiliate-header-close' onClick={() => setAddMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#85888E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='add-affiliate-body'>
        <div className='add-affiliate-body-section'>
          <div className='add-affiliate-body-title'>
            <div className='add-affiliate-body-title-text'>
              Email
            </div>
          </div>
        </div>
        <div className='add-affiliate-body-input-frame'>
          <input
            className='add-affiliate-body-input'
            onChange={(e) => setEmail(e.target.value)}
            placeholder='Enter email here...'
          />
        </div>
      </div>
      <div className='upload-aff-file-footer'>
        <div className='upload-aff-file-footer-content'>
          <div className='upload-aff-file-footer-cancel' onClick={() => setAddMode(false)}>
            <div className='upload-aff-file-footer-cancel-text'>
              Cancel
            </div>
          </div>
          <div className='upload-aff-file-footer-done' onClick={() => requestJoin(email)}>
            <div className='upload-aff-file-footer-done-text'>
              Send Invite
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAffiliate;
